import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
const TooltipStyled = styled(({ className, ...props }) => (React.createElement(Tooltip, { ...props, classes: { popper: className } })))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        padding: '0',
        backgroundColor: 'transparent',
        maxWidth: 'max-content'
    }
}));
// eslint-disable-next-line react/require-default-props
export const TooltipMui = (props) => (React.createElement(TooltipStyled, { ...props, followCursor: true }));
TooltipMui.displayName = 'TooltipMui';
